import { useEffect, useState } from 'react';
import { Button, Modal } from '../components/ui';
import '../components/ui/common.css';
import { weightAPI } from '../services/api';
import './Dashboard.css';

const Weight = () => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [formData, setFormData] = useState({ weight: '', date: '' });

    useEffect(() => {
        loadRecords();
    }, []);

    const loadRecords = async () => {
        try {
            const response = await weightAPI.getAll();
            setRecords(response.data);
        } catch (error) {
            console.error('Error loading records:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingRecord) {
                await weightAPI.update(editingRecord.id, formData);
            } else {
                await weightAPI.create(formData);
            }
            setModalOpen(false);
            setEditingRecord(null);
            setFormData({ weight: '', date: '' });
            loadRecords();
        } catch (error) {
            console.error('Error saving record:', error);
            alert('Ошибка при сохранении');
        }
    };

    const handleEdit = (record) => {
        setEditingRecord(record);
        setFormData({
            weight: record.weight,
            date: record.date.split('T')[0]
        });
        setModalOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Удалить запись?')) return;
        try {
            await weightAPI.delete(id);
            loadRecords();
        } catch (error) {
            console.error('Error deleting record:', error);
            alert('Ошибка при удалении');
        }
    };

    const openAddModal = () => {
        setEditingRecord(null);
        setFormData({ weight: '', date: new Date().toISOString().split('T')[0] });
        setModalOpen(true);
    };

    const latestWeight = records.length > 0 ? records[0] : null;

    if (loading) {
        return <div className="loading">Загрузка...</div>;
    }

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1>Вес</h1>
                    {latestWeight && (
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', marginTop: '1rem' }}>
                            {latestWeight.weight} кг
                            {latestWeight.difference !== null && (
                                <span className={`difference ${latestWeight.difference > 0 ? 'negative' : 'positive'}`}
                                    style={{ marginLeft: '1rem', fontSize: '1.5rem' }}>
                                    {latestWeight.difference > 0 ? '+' : ''}{latestWeight.difference}
                                </span>
                            )}
                        </div>
                    )}
                </div>
                <Button onClick={openAddModal}>+ Добавить</Button>
            </div>

            {records.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">⚖️</div>
                    <p>Нет записей веса</p>
                    <Button onClick={openAddModal}>Добавить первую запись</Button>
                </div>
            ) : (
                <div>
                    {records.map((record) => {
                        const isPositive = record.difference !== null && record.difference <= 0;
                        const isNegative = record.difference !== null && record.difference > 0;
                        return (
                            <div
                                key={record.id}
                                className={`list-item ${isPositive ? 'positive' : ''} ${isNegative ? 'negative' : ''}`}
                            >
                                <div className="list-item-content">
                                    <div style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                                        {record.weight} кг
                                        {record.difference !== null && (
                                            <span style={{ marginLeft: '1rem', fontSize: '1rem' }}>
                                                ({record.difference > 0 ? '+' : ''}{record.difference} кг)
                                            </span>
                                        )}
                                    </div>
                                    <div style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                                        {new Date(record.date).toLocaleDateString('ru-RU')}
                                    </div>
                                </div>
                                <div className="list-item-actions">
                                    <button className="icon-btn" onClick={() => handleEdit(record)}>✏️</button>
                                    <button className="icon-btn" onClick={() => handleDelete(record.id)}>🗑️</button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            <Modal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title={editingRecord ? 'Редактировать вес' : 'Добавить вес'}
                footer={
                    <>
                        <Button variant="secondary" onClick={() => setModalOpen(false)}>Отмена</Button>
                        <Button onClick={handleSubmit}>Сохранить</Button>
                    </>
                }
            >
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="weight">Вес (кг)</label>
                        <input
                            id="weight"
                            type="number"
                            step="0.1"
                            value={formData.weight}
                            onChange={(e) => setFormData({ ...formData, weight: e.target.value })}
                            required
                            placeholder="75.5"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="date">Дата</label>
                        <input
                            id="date"
                            type="date"
                            value={formData.date}
                            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                            required
                        />
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default Weight;
